import React, { Component } from "react";
import axios from "axios";

import Item from "./Item";
import Message from "../Message";
import AuthContext from "../../context/auth-context";
import Modal from "./Modal";
import SearchBar from "./SearchBar";
import Chart from "./Chart";
import {
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Spinner,
} from "reactstrap";
import { useHistory } from "react-router-dom";

import "./task.scss";

class TaskPage extends Component {
  state = {
    createdTasks: [], //Initial Created Tasks
    archivedTasks: [], //Initial Archived Tasks
    searchedCreatedTasks: [], //Sorted Created Tasks based on Search
    searchedArchivedTasks: [], //Sorted Archived Tasks based on Search
    filteredCreatedTasks: [], //Filtered the created tasks based on the type of label and status
    filteredArchivedTasks: [], //Filtered the archived tasks based on the type of label and status
    sortedCreatedTasks: [], //Sorted On Due Date
    sortedArchivedTasks: [], //Sorted based in due date
    loading: false,
    loadingIni: false,
    taskType: "createdTasks",
    isCreating: false,
    title: "",
    dueDate: "",
    label: "Personal",
    status: "New",
    description: "",
  };

  allLabels = ["Personal", "Work", "Shopping", "Others"];

  allStatus = ["New", "In Progress", "Completed"];

  static contextType = AuthContext;

  //Load Tasks on Component Load
  loadTasks = async () => {
    this.setState({ loadingIni: true });
    try {
      const res = await axios.get(
        " https://myhacktaskmanager.herokuapp.com/api/tasks",
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": `${this.context.token}`,
          },
        }
      );
      this.setState({
        loadingIni: false,
        createdTasks: res.data.createdTasks,
        archivedTasks: res.data.archivedTasks,
        searchedCreatedTasks: res.data.createdTasks,
        searchedArchivedTasks: res.data.archivedTasks,
        filteredCreatedTasks: res.data.createdTasks,
        filteredArchivedTasks: res.data.archivedTasks,
        sortedCreatedTasks: res.data.createdTasks,
        sortedArchivedTasks: res.data.archivedTasks,
      });
    } catch (err) {
      if (err.response) {
        this.context.createMessage(false, err.response.data.msg);
        this.setState({ loadingIni: false });
      }
    }
  };

  async componentDidMount() {
    await this.loadTasks();
  }

  logoutHandler = () => {
    this.setState({ loading: true });
    this.context.logout();
    this.setState({ loading: false });
  };

  /*
Note: 

Q: How these state updating functions works?
Ans: Any Request (Update/ Delete/ Archive) is sent to the server. Once the request is completed and the changes are done on the backend, frontend receives a 200 OK status after which
    these functions are called which updates the frontend based on the required operation like Update (Created Task), Delete (Created Task/ Archived Task), Archive Created Task, Sort, Search, Filter
    in the Created and Archived Tasks which would rather give the same list of tasks as response as that fetched from backend.

Q: Why different types of the created and archived tasks in the state?
Ans: These different types are to store different filtered tasks based on the parameter as reverting back to previous state of the filtering will ot be possible without them.
*/

  updateTasks = (task) => {
    const newCreatedTask = this.state.createdTasks;
    for (let i = 0; i < newCreatedTask.length; i++) {
      if (newCreatedTask[i]._id === task._id) {
        newCreatedTask[i] = task;
        break;
      }
    }

    this.setState({
      createdTasks: newCreatedTask,
      searchedCreatedTasks: newCreatedTask,
      filteredCreatedTasks: newCreatedTask,
      sortedCreatedTasks: newCreatedTask,
    });
  };

  taskArchival = (task) => {
    //Deleting task from created Tasks
    const newCreatedTask = this.state.createdTasks;
    for (let i = 0; i < newCreatedTask.length; i++) {
      if (newCreatedTask[i]._id === task._id) {
        newCreatedTask.splice(i, 1);
        break;
      }
    }

    //Updating all types of Created Tasks with the created Tasks after deletion of the archived Task
    //Inserting the new Archived Task in all types of Archived Tasks
    this.setState((prevState) => {
      return {
        archivedTasks: [...prevState.archivedTasks, task],
        createdTasks: newCreatedTask,
        searchedArchivedTasks: [...prevState.archivedTasks, task],
        searchedCreatedTasks: newCreatedTask,
        filteredArchivedTasks: [...prevState.archivedTasks, task],
        filteredCreatedTasks: newCreatedTask,
        sortedArchivedTasks: [...prevState.archivedTasks, task],
        sortedCreatedTasks: newCreatedTask,
      };
    });
  };

  deleteCreatedTask = async (task) => {
    //Deleting Task from created task
    const newCreatedTask = this.state.createdTasks;
    for (let i = 0; i < newCreatedTask.length; i++) {
      if (newCreatedTask[i]._id === task._id) {
        newCreatedTask.splice(i, 1);
        break;
      }
    }
    //Updating all types of Created Tasks with the created Tasks after deletion of the deleted Task
    this.setState({
      createdTasks: newCreatedTask,
      searchedCreatedTasks: newCreatedTask,
      filteredCreatedTasks: newCreatedTask,
      sortedCreatedTasks: newCreatedTask,
    });
  };

  deleteArchivedTask = (task) => {
    //Delete Task from Archived Tasks
    const newArchivedTask = this.state.archivedTasks;
    for (let i = 0; i < newArchivedTask.length; i++) {
      if (newArchivedTask[i]._id === task._id) {
        newArchivedTask.splice(i, 1);
        break;
      }
    }

    //Updating all types of Archived Tasks with the created Tasks after deletion of the deleted Task
    this.setState({
      archivedTasks: newArchivedTask,
      searchedArchivedTasks: newArchivedTask,
      filteredArchivedTasks: newArchivedTask,
      sortedArchivedTasks: newArchivedTask,
    });
  };

  createToggle = () => {
    this.context.createMessage(false, null);
    this.setState((prevState) => {
      return { isCreating: !prevState.isCreating };
    });
  };

  createTask = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    const { title, description, label, status, dueDate } = this.state;
    if (!title || !description || !status || !label || !dueDate) {
      this.context.createMessage(false, "Fill All the Fields");
      this.setState({
        loading: false,
      });
      this.setState((prevState) => {
        return { isCreating: !prevState.isCreating };
      });
      return;
    }
    const body = {
      name: title,
      dueDate: dueDate,
      label: label,
      status: status,
      description: description,
    };
    console.log(body);
    try {
      const res = await axios.post(
        " https://myhacktaskmanager.herokuapp.com/api/tasks",
        body,
        {
          params: {
            ui: this.context.user._id,
          },
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": `${this.context.token}`,
          },
        }
      );
      this.context.createMessage(true, res.data.msg);
      this.setState((prevState) => {
        return {
          createdTasks: [...prevState.createdTasks, res.data.task],
          searchedCreatedTasks: [...prevState.createdTasks, res.data.task],
          filteredCreatedTasks: [...prevState.createdTasks, res.data.task],
          sortedCreatedTasks: [...prevState.createdTasks, res.data.task],
        };
      });

      this.setState({
        loading: false,
        label: "Personal",
        status: "New",
        title: "",
        dueDate: "",
        description: "",
        taskType: "createdTasks",
      });
      this.createToggle();
    } catch (err) {
      if (err.response) {
        this.context.createMessage(false, err.response.msg);
        this.setState({
          loading: false,
          label: "Personal",
          status: "New",
          title: "",
          dueDate: "",
          description: "",
          taskType: "createdTasks",
        });
        this.createToggle();
        let history = useHistory();
        history.push("/auth");
      }
    }
  };

  //Search The tasks with the given name
  searchTasks = async (input) => {
    this.context.createMessage(false, null);

    //If input is empty string
    if (input === "") {
      this.setState({
        searchedCreatedTasks: this.state.sortedCreatedTasks,
        searchedArchivedTasks: this.state.sortedArchivedTasks,
      });
    } else {
      //filter sorted createdTasks based on input
      const searchedCreate = this.state.sortedCreatedTasks.filter((task) => {
        return task.name.toLowerCase().includes(input.toLowerCase());
      });
      //filter sorted archivedTasks based on input
      const searchedArchive = this.state.sortedArchivedTasks.filter((task) => {
        return task.name.toLowerCase().includes(input.toLowerCase());
      });
      //update state
      this.setState({
        searchedCreatedTasks: searchedCreate,
        searchedArchivedTasks: searchedArchive,
      });
    }
  };

  //Filter task on given parameter
  filterTasks = async (param, input) => {
    this.context.createMessage(false, null);

    //If neither of the filter is applied
    if (
      input === "Select Label" ||
      input === "All" ||
      input === "Select Status"
    ) {
      this.setState({
        filteredCreatedTasks: this.state.createdTasks,
        filteredArchivedTasks: this.state.archivedTasks,
        sortedCreatedTasks: this.state.createdTasks,
        sortedArchivedTasks: this.state.archivedTasks,
      });
    } else {
      //if filter is applied than filter created and archived task based on it
      const filteredCreate = this.state.createdTasks.filter((task) => {
        return task[param] === input;
      });
      const filteredArchive = this.state.archivedTasks.filter((task) => {
        return task[param] === input;
      });

      //update state
      this.setState({
        filteredCreatedTasks: filteredCreate,
        filteredArchivedTasks: filteredArchive,
        sortedCreatedTasks: filteredCreate,
        sortedArchivedTasks: filteredArchive,
      });
    }
  };

  //sort tasks based on due date priority
  sortTasks = async (e) => {
    this.context.createMessage(false, null);
    //if sort applied then
    if (e) {
      //sort createdTasks and archivedTasks
      const newCreatedSort = await [
        ...this.state.sortedCreatedTasks,
      ].sort((a, b) => (a.dueDate > b.dueDate ? 1 : -1));
      const newArchivedSort = await [
        ...this.state.sortedArchivedTasks,
      ].sort((a, b) => (a.dueDate > b.dueDate ? 1 : -1));

      //update state
      await this.setState({
        sortedArchivedTasks: newArchivedSort,
        sortedCreatedTasks: newCreatedSort,
      });
    } else {
      //else update state to the initial one
      await this.setState({
        sortedCreatedTasks: this.state.filteredCreatedTasks,
        sortedArchivedTasks: this.state.filteredArchivedTasks,
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <Modal
          modal={this.state.isCreating}
          toggle={this.createToggle}
          title={"Event Creation"}
        >
          <Form onSubmit={this.createTask}>
            <FormGroup>
              <Label for="exampleTitle">Title</Label>
              <Input
                type="text"
                name="title"
                id="exampleTitle"
                placeholder="Enter Event Title"
                isRequired
                onChange={(e) => this.setState({ title: e.target.value })}
              />
            </FormGroup>
            <FormGroup>
              <Label for="exampleDescription">Description</Label>
              <Input
                type="textarea"
                name="description"
                id="exampleDescription"
                placeholder="Enter Event Description"
                isRequired
                onChange={(e) => this.setState({ description: e.target.value })}
              />
            </FormGroup>
            <FormGroup>
              <Label for="exampleLabel">Label</Label>
              <select
                id="exampleLabel"
                className="form-control"
                value={this.state.label}
                isRequired
                onChange={(e) => this.setState({ label: e.target.value })}
              >
                {this.allLabels.map((label, i) => (
                  <option key={i} value={label}>
                    {label}
                  </option>
                ))}
              </select>
            </FormGroup>
            <FormGroup>
              <Label for="exampleStatus">Status</Label>
              <select
                className="form-control"
                value={this.state.status}
                onChange={(e) => this.setState({ status: e.target.value })}
              >
                {this.allStatus.map((status, i) => (
                  <option key={i} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </FormGroup>

            <FormGroup>
              <Label for="exampleDue">Due Date</Label>
              <Input
                type="date"
                name="dueDate"
                id="exampleDue"
                placeholder="Enter Event Due Date"
                isRequired
                onChange={(e) => this.setState({ dueDate: e.target.value })}
              />
            </FormGroup>
            <ModalFooter className="justify-content-between">
              <Button
                className="mr-1"
                color="primary"
                type="submit"
                value="Submit"
              >
                Create &nbsp;
                {this.state.loading && (
                  <>
                    &nbsp;
                    <Spinner size="sm" color="white" />
                    &nbsp;
                  </>
                )}
              </Button>{" "}
              <Button color="secondary" onClick={this.createToggle}>
                Cancel
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
        <div className="task-div">
          <div className="actionBar">
            <button
              className="btn btn-lg btn-primary"
              onClick={this.createToggle}
            >
              Create
            </button>
            <h3>Tasks</h3>
            <button
              className="btn btn-lg btn-danger"
              onClick={() => this.logoutHandler()}
            >
              Logout
              {this.state.loading && (
                <>
                  &nbsp;&nbsp;
                  <Spinner size="sm" color="white" />
                  &nbsp;&nbsp;
                </>
              )}
            </button>
          </div>
          <SearchBar
            searchTasks={this.searchTasks}
            filterTasks={this.filterTasks}
            sortTasks={this.sortTasks}
          />
          {this.context.msg && (
            <Message status={this.context.status} msg={this.context.msg} />
          )}
          <div className="task-bar">
            <button
              className={`btn btn-lg ${
                this.state.taskType === "createdTasks" ? "active" : ""
              }`}
              onClick={() => {
                this.setState({ taskType: "createdTasks" });
                this.context.createMessage(false, null);
              }}
            >
              Active
            </button>
            <button
              className={`btn btn-lg ${
                this.state.taskType === "archivedTasks" ? "active" : ""
              }`}
              onClick={() => {
                this.setState({ taskType: "archivedTasks" });
                this.context.createMessage(false, null);
              }}
            >
              Archived
            </button>
            <button
              className={`btn btn-lg ${
                this.state.taskType === "visual" ? "active" : ""
              }`}
              onClick={() => {
                this.setState({ taskType: "visual" });
                this.context.createMessage(false, null);
              }}
            >
              Stats
            </button>
          </div>
          {this.state.loadingIni ? (
            <Spinner color="primary" className="bigSpinner" />
          ) : (
            <React.Fragment>
              {this.state.taskType === "createdTasks" &&
                (this.state.searchedCreatedTasks.length === 0 ? (
                  <h2 className="emptyText">No Task Created Now</h2>
                ) : (
                  <ul className="taskList">
                    {this.state.searchedCreatedTasks.map((task, i) => (
                      <Item
                        task={task}
                        key={i}
                        user={this.context.user}
                        updateTasks={this.updateTasks}
                        taskArchival={this.taskArchival}
                        taskType={this.state.taskType}
                        taskDeletion={this.deleteCreatedTask}
                      />
                    ))}
                  </ul>
                ))}
              {this.state.taskType === "archivedTasks" &&
                (this.state.searchedArchivedTasks.length === 0 ? (
                  <h2 className="emptyText">No Task Archived</h2>
                ) : (
                  <ul className="taskList">
                    {this.state.searchedArchivedTasks.map((task, i) => (
                      <Item
                        task={task}
                        key={i}
                        user={this.context.user}
                        updateTasks={this.updateTasks}
                        taskArchival={this.taskArchival}
                        taskDeletion={this.deleteArchivedTask}
                      />
                    ))}
                  </ul>
                ))}
              {this.state.taskType === "visual" &&
                (this.state.archivedTasks.length +
                  this.state.createdTasks.length ===
                0 ? (
                  <h2 className="emptyText">No Data to Visualize</h2>
                ) : (
                  <Chart
                    createdTasks={this.state.createdTasks}
                    archivedTasks={this.state.archivedTasks}
                  />
                ))}
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default TaskPage;
